import React from 'react';

export const Stack = ({
    size = 0,
    children,
    // role,
    height,
    width,
    maxWidth,
    zIndex,
    justifyContent,
    alignItems,
    display,
}: StackType) => {
    return (
        <div
            style={{
                flexDirection: 'column',
                // backgroundColor: mapRoleToBackgroundColor(role),
                height,
                width,
                maxWidth,
                zIndex,
                justifyContent,
                alignItems,
                display
            }}
        >
            {React.Children.toArray(children).map((child, index) => {
                if (index == 0) {
                    return <div key={index}>{child}</div>;
                }
                return (
                    <div key={index}>
                        <div style={{horizontal: "true", margin: `${size}px`}} />                            
                        {child}
                    </div>
                );
            })}
        </div>
    );
};
